<template>
  <div>
    <h2 class="i-mb-8">Join your team</h2>
    <p v-if="!isSamlStrictModeEnabled" class="i-mb-8">
      Before you can join your team on Inscribe, we just need your name and a
      password.
    </p>
    <p v-else class="i-mb-8">
      Before you can join your team on Inscribe, we just need your name.
    </p>
    <form>
      <text-input
        :auto-focus="true"
        :value="firstName"
        :max-length="30"
        placeholder="Harry"
        label="First name"
        name="first-name"
        type="text"
        @input="firstName = $event"
      />
      <text-input
        :value="lastName"
        placeholder="Markopolos"
        :max-length="30"
        label="Last name"
        name="last-name"
        type="text"
        @input="lastName = $event"
      />
      <div v-if="!isSamlStrictModeEnabled">
        <password-input
          :value="password"
          label="Password"
          @input="password = $event"
        />
        <text-input
          :value="passwordConfirmation"
          placeholder="One more time"
          label="Confirm password"
          name="confirm-password"
          type="password"
          :error="!doPasswordsMatch"
          validation-message="Your passwords don't match"
          @input="passwordConfirmation = $event"
        />
      </div>
      <loading-button
        :disabled="
          !firstName ||
          !lastName ||
          (!isSamlStrictModeEnabled && (!isValidPassword || !doPasswordsMatch))
        "
        :loading="loading"
        @click="joinOrganisation"
      >
        Register
      </loading-button>
    </form>
  </div>
</template>

<script>
import { LoadingButton, TextInput } from '@inscribe/ui-kit';
import { isValidPassword } from '../utils/validation';
import PasswordInput from './PasswordInput';

export default {
  components: {
    'loading-button': LoadingButton,
    'text-input': TextInput,
    'password-input': PasswordInput,
  },
  props: {
    invitationCode: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      loading: false,
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirmation: '',
    };
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.password);
    },
    doPasswordsMatch() {
      return this.password === this.passwordConfirmation;
    },
    isSamlStrictModeEnabled() {
      return this.$route.query.samlStrictMode === 'True';
    },
  },
  methods: {
    joinOrganisation() {
      if (
        ((this.isValidPassword && this.doPasswordsMatch) ||
          this.isSamlStrictModeEnabled) &&
        !this.loading
      ) {
        this.loading = true;
        const data = new FormData();
        data.append('first_name', this.firstName);
        data.append('last_name', this.lastName);
        data.append('password', this.password);
        data.append('password_confirmation', this.passwordConfirmation);
        data.append('invitation_code', this.invitationCode);
        this.$store
          .dispatch('joinOrganisation', data)
          .then(() => {
            this.loading = false;
            if (this.isSamlStrictModeEnabled) {
              this.$router.push({ name: 'login-saml' });
            } else {
              this.$router.push({ name: 'login' });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$notify({
              group: 'general',
              type: 'error',
              title: 'There was a problem joining your team',
              duration: 5000,
              text: error.response.data.message,
            });
          });
      }
    },
  },
};
</script>
